export default __webpack_public_path__ + "static/O0285-7c24c677425c266b0a37f472243932f4.png";